import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class DatalayerService {

  constructor(@Inject(PLATFORM_ID) private platformId: Object) {}

  push(event: string, data: any = {}): void {
    if (!isPlatformBrowser(this.platformId)) return;

    (window as any).dataLayer = (window as any).dataLayer || [];

    (window as any).dataLayer.push({
      event,
      ...data
    });
  }

}
